
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["sc-logo",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{staticClass:"sc-logo-border",attrs:{"d":"M0 20h20V0H0v20zm1.333-1.334h17.334V1.333H1.333v17.333z"}}),_c('path',{attrs:{"d":"M4 4v12h12zM15.057 12.485L7.515 4.942 8.457 4 16 11.542zM15.057 8.714l-3.771-3.772.943-.942 3.77 3.77z"}})])])
          )
        }
      }
    